<router-outlet></router-outlet>

<simple-notifications [options]="notificationOptions"></simple-notifications>
